import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNetappComponent } from './simple-icons-netapp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNetappComponent ],
    exports:      [ SimpleIconsNetappComponent ],
    bootstrap:    []
})
export class SimpleIconsNetappModule {}
